<template>
  <!--对话框 获取员工列表-->
  <el-dialog
    :visible="isShow"
    :width="width"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    :append-to-body="true"
    :show-close="false"
  >
    <div slot="title" class="dialog-title-container">
      <span class="title-label"
        ><i class="el-icon-user-solid"></i> 员工选择</span
      >
      <i class="el-icon-error" @click="close"></i>
    </div>
    <el-button
      type="success"
      size="mini"
      icon="el-icon-finished"
      @click="enterHandler"
      >确定选择</el-button
    >
    <div class="dialog-search-container">
      <el-input
        size="mini"
        placeholder="请输入员工姓名"
        v-model="query.customerName"
      >
        <template slot="prepend">搜索：</template>
        <el-button
          slot="append"
          icon="el-icon-search"
          @click="searchHandler"
        ></el-button>
      </el-input>
    </div>
    <div class="dialog-main-container">
      <el-table
        :data="ds"
        size="mini"
        height="410px"
        style="width: 100%;"
        stripe
        border
        header-row-class-name="list-header-row"
        row-class-name="list-row"
        @selection-change="selectHandler"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        ></el-table-column>
        <el-table-column
          label="员工姓名"
          prop="name"
          header-align="center"
        ></el-table-column>
        <el-table-column
          label="职务"
          prop="position_title"
          header-align="center"
        ></el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          :page-size="query.pageSize"
          :page-count="query.pageSize"
          layout="prev, pager, next"
          :total="query.totalCount"
        ></el-pagination>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "EzzDialogEmployee",
  props: {
    parent: {
      type: Object,
      default: () => null
    },
    width: {
      type: String,
      default: "50%"
    }
  },
  data: function() {
    return {
      isShow: false,
      ds: [],
      query: {
        employeeIds: "0",
        employeeName: "",
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 1
      },
      selectedDs: []
    };
  },
  mounted: function() {},
  methods: {
    loadData: function() {
      const _this = this;
      _this.post(_this.$apis.getEmployeesForDepartment, _this.query, function(
        res
      ) {
        let _json = res.data;
        _this.ds = _json.datalist;
        _this.query.totalCount = _json.totalCount;
      });
    },
    open: function(employees) {
      let employeeIds = [];
      employees.forEach(el => {
        employeeIds.push(el.employee_id);
      });
      this.query.employeeIds = employeeIds.join(",");
      this.loadData();
      this.isShow = true;
    },
    close: function() {
      this.isShow = false;
    },
    // 多选事件
    selectHandler: function(selection) {
      this.selectedDs = selection;
    },
    // 搜索事件
    searchHandler: function() {
      this.query.pn = 1;
      this.loadData();
    },
    // 确定选择事件
    enterHandler: function() {
      const _this = this;
      let _selectedCount = this.selectedDs.length;
      for (let i = 0; i < _selectedCount; ++i) {
        // 此处必须进行深拷贝，否则添加的明细，将都指向了一个对象
        let _newDetail = JSON.parse(
          JSON.stringify(_this.parent.formDetailEmptyData)
        );
        _newDetail.department_id = _this.parent.formData.id;
        _newDetail.employee_id = _this.selectedDs[i].id;
        _newDetail.employee_name = _this.selectedDs[i].name;
        _newDetail.employee_code = _this.selectedDs[i].code;
        _newDetail.sex = _this.selectedDs[i].sex;
        _newDetail.card_no = _this.selectedDs[i].cardNo;
        _newDetail.phone = _this.selectedDs[i].phone;
        _newDetail.email = _this.selectedDs[i].email;
        _newDetail.is_part_timer = _this.selectedDs[i].is_part_timer;
        _this.parent.formData.employees.push(_newDetail);
      }
      _this.close();
    }
  }
};
</script>
